fourToldApp.controller("deleteuserCntrl", function($scope, esb, services, $window, $location, $mdToast, $mdDialog, countries, theme, $httpParamSerializer) {
    $scope.forgotPassword = new Object();
    var activeDiv = document.querySelector('html');
    $scope.theme = JSON.parse($window.sessionStorage.getItem("theme"));
    $scope.progressCircular = true;
    $scope.dial_codes = countries;
    $scope.theme = theme.getTheme();
    $scope.doubleValidationToken="123";
    $scope.deviceIMEIExecuter=encodeURIComponent($window.navigator.appCodeName);
    $scope.deviceIdExecuter= encodeURIComponent($window.navigator.appName);
    $scope.showByID = false;
    $scope.docTypes;
    $scope.labelNumberPhone = "Número de teléfono";

    var userData = {};
    $scope.tipo_borrado = [{
        'cod': 'USERNAME',
        'description': 'Usuario o número de teléfono'
         }, {
        'cod': 'ID',
        'description': 'ID'
         }
        ];

    if(esb === 'https://esb.holaprestamo.com.co')
        $location.path('/');
    
    if ($window.localStorage.getItem("phoneNumberDeleted") && $window.localStorage.getItem("usernameSupport")) {
        $scope.usernameSupport = $window.localStorage.getItem("usernameSupport");
        $scope.phonenumber = $window.localStorage.getItem("phoneNumberDeleted");
        
    }

    services.docTypes().docTypes({tag:$location.search().tag}, function(response){        
        if(response.code ==1 && response.data && response.data[0].field4 !== undefined){
            $scope.docTypes = JSON.parse(response.data[0].field4);
            console.log( $scope.docTypes);
        }
        else{
            console.log("No hay tipo de documentos");
        }

    }, function error(response){
        console.log("error doctypes");

    });

    $scope.rememberMe = function() {        
          window.localStorage.setItem('phoneNumberDeleted', $scope.phonenumber);
          window.localStorage.setItem('usernameSupport', $scope.usernameSupport);
    };

    $scope.type_delete_selected = function() {
        if($scope.cod_type =='ID'){
            $scope.labelNumberPhone = "Número de identificación";
        }
        else{
            $scope.labelNumberPhone = "Número de teléfono";
        }
     }
  
    function DialogController($scope, $mdDialog, items) {
        $scope.items = items;
        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.answer = function(answer) {
            $mdDialog.hide(answer);
        };
    }


    $scope.dialogTag = function(data, token, idType, country, idDocType) {
        $mdDialog.show({
                controller: DialogController,
                locals: {
                    items: data
                },
                templateUrl: '../views/pages/tags.html',
                parent: angular.element(document.body)
            })
            .then(function(tag) {
                if (tag) {
                    console.log(tag)
                    deleteUserServiceTag(token, tag, idType, country, idDocType)
                }
            }, function(cancel) {});
    };


  
    $scope.showAlert = function(message) {
        $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#popupContainer')))
            .clickOutsideToClose(true)
            .title('Notificación')
            .textContent(message)
            .ariaLabel('Alert Dialog Demo')
            .ok('Ok')
        );
    };
  
    $scope.login = function() {
      $location.path('/');
    };


        deleteUserService = function(token, recursive, idType, country, idDocType) {

            if(recursive) {
                deleteUserServiceTag(token, $scope.tag, idType, country, idDocType)

            } 
            else {
                var appTag = getTagFromUrl();
                console.log(appTag);
     
            
                if(appTag != null && appTag !== "") {
                    deleteUserServiceTag(token, appTag, idType, country, idDocType)
                }
                else {
                    var numeroTelf = $scope.phonenumber.toString();
                    var data = {userName: numeroTelf}
                    services.userTags().getTags(data,
                        function(response) {
                            console.log(response.data)
                            var tags = response.data;
                            if(tags.length == 0) {
                                deleteUserServiceTag(token, tag, idType, country, idDocType)
                            } else if(tags.length == 1) {
                                var tag = tags[0].id
                                deleteUserServiceTag(token, tag, idType, country, idDocType)
                            } else {
                              // is a list
        
                              $scope.dialogTag(tags, token, idType, country, idDocType)
        
        
                            }
        
        
                        },
                        function error(response) {console.log("error getTag")});
                }
            }
        }
         
        deleteUserServiceTag = function(token, appTag, idType, country, idDocType){
            $scope.tag = appTag;
            var numeroTelf = $scope.phonenumber.toString();

            if(idType == 'USERNAME'){
                if (numeroTelf.charAt(0) !== '+')
                numeroTelf = "+" + numeroTelf;
            }
            
            $scope.numeroTelf = numeroTelf;
            numeroTelf = encodeURIComponent(numeroTelf);
            var sendTag = false;
            if(appTag != null && appTag !== "" && appTag != undefined) {
                numeroTelf += '|' + appTag;
                sendTag = appTag;
            }

            console.log("Numero telefofono: " + numeroTelf);
            $scope.progressEdit = "ok";




            userData =  services.deleteUser('bearer ' +token, numeroTelf, sendTag, idType, country, idDocType).delete({doubleValidationToken: $scope.doubleValidationToken,
                                                                                       deviceIMEIExecuter: $scope.deviceIMEIExecuter, deviceIdExecuter: $scope.deviceIdExecuter}, 
                                                                                       {}, 
                        function(response){
                            $scope.progressEdit = undefined;                 
                            console.log(response);
                            if(response!=null){
                                if(response.code === 1){
                                    if(response.doubleValidationToken!=null){
                                        $scope.doubleValidationToken =  response.doubleValidationToken;
                                        deleteUserService(token, true, idType, country, idDocType);
                                    }
                                    else{
                                        $scope.rememberMe();
                                        $scope.showAlert("Usuario " + $scope.numeroTelf + " eliminado exitosamente");  

                                    }

                                }
                                else{
                                    var errorMessage = "";
                                    switch(response.code){
                                        case -2:
                                            errorMessage = "Usuario no existe";
                                            break;
                                        case -8: 
                                            errorMessage = "No tienes permisos suficientes";
                                            break;
                                        default:
                                            errorMessage = response.message;
                                        break;

                                    }
                                    $scope.progressEdit = undefined;
                                    $scope.showAlert(errorMessage); 
                                }

                            }
                            else{
                                $scope.progressEdit = undefined;
                                $scope.showAlert("Ha ocurrido un error en la llamada al servicio");
                            }
                        
                    }, function(error){
                        console.log("Error en delete user")
                        $scope.progressEdit = undefined;

                    });

        }

    $scope.submit = function() {
        if ($scope.usernameSupport && $scope.password && $scope.phonenumber ) {
            var numeroTelf = $scope.phonenumber.toString();
            if(!$scope.cod_type){
                $scope.showAlert("Debe seleccionar el parametro de tipo de borrado");
                return;
            }
         
            if($scope.cod_type =='ID'){
                if(!$scope.code_country){
                    $scope.showAlert("Debe seleccionar un pais");
                    return;
                }
                if(!$scope.code_docType){
                    $scope.showAlert("Debe seleccionar un tipo de documento");
                    return;
                }

            }
            else{
                if (numeroTelf.charAt(0) !== '+')
                numeroTelf = "+" + numeroTelf;
            }
            

                $scope.loginError = false;


                var confirm = $mdDialog.confirm()
                .textContent('Quieres borrar el usuario '+ numeroTelf + '?')
                .ariaLabel('enviar')                
                .cancel('Cancelar')
                .ok('Aceptar');               
          $mdDialog.show(confirm).then(function() {
            $scope.progressEdit = "ok";

            var data = $httpParamSerializer({
                grant_type: "password",
                username: $scope.usernameSupport,
                password: $scope.password
            });

            var token = 'Basic ' + window.btoa("4told-fin-api:secret");
            services.login(token).login({}, data, function(response) {
                $('#main-content').removeClass('merge-left');
                var now = new $window.Date(),
                    exp = new $window.Date(now.getFullYear(), now.getMonth() + 6, now.getDate());

                if (response.access_token) {
                    console.log("Access token: " + response.access_token);
                    $scope.progressEdit = undefined;

                    deleteUserService(response.access_token, false, $scope.cod_type, $scope.code_country, $scope.code_docType);


                  
                } else {
                   // $scope.dialog("Usuario o contraseña inválidos", "error-toast");
                    $scope.loginError = true
                    $scope.progressEdit = undefined;
                }
            }, function(error) {
                console.log(error);
                $scope.dialog("Ocurrio un error, intente de nuevo", "error-toast");
                $scope.loginError = true
                $scope.progressEdit = undefined;
            })
   
          }, function(){$scope.docFile = undefined;});            
        }
    }

    
    $scope.dialog = function(message, type) {
        $scope.progressEdit = undefined;
        $mdToast.show(
            $mdToast.simple()
            .textContent(message)
            .position('top')
            .action('Ok')
            .theme(type)
            .hideDelay(0)
        ).then(function(answer) {
            if(answer === "ok")
              $scope.loginError = false;
          });
    };

    $scope.visibility = function() {
        var x = document.getElementById("password");
        if (x.type === "password") {
            x.type = "text";
            $scope.passwordVisibility = true;
        } else {
            x.type = "password";
            $scope.passwordVisibility = false;
        }
    }
    getTagFromUrl = function () {
        let urlData =  $location.search();
        let urlTag = urlData['tag'];

        if(urlTag) {
            return urlTag.toUpperCase();
        }
        return urlTag;
    }
  });
  